import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./renewPrescription_success_popup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import CloseButton from "../../closeButton/closeButton";

function RenewPrescriptionPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup}>
      <CloseButton onClick={onClose} />
      <h2 className={popupStyles.popup__title}>{t('REQUEST_RECEIVED')}</h2>
      <p className={popupStyles.popup__text}>
        {t('RENEWAL_OF_REGISTRATION')}</p>
      <img
        src={doctor}
        alt="Docktor picture"
        className={popupStyles.popup__img}
      />
      <button
        type="button"
        className={`${popupStyles.popup__nextBtn} hover`}
        onClick={onClose}
      >
        {t('APPROVAL')}</button>
    </article>
  );
}

export default RenewPrescriptionPopup;
